import { endpoints } from "./endpoints/endpoints";

export enum OutletServiceAction {
    GET_CITY = 'getCity',
    SEARCH = 'search',
    UPDATE = 'update',
    DELETE = 'delete',
    ADD = 'add'
}

export default async function OutletService(action:string,request:any,csrf:string){
    let url = ''
    switch(action){
        case OutletServiceAction.GET_CITY : url = endpoints.outlet.getCity;
        break;
        case OutletServiceAction.ADD : url = endpoints.outlet.submit;
        break;
        case OutletServiceAction.UPDATE : url = endpoints.outlet.submit;
        break;
        case OutletServiceAction.DELETE : url = endpoints.outlet.delete;
        break;
        case OutletServiceAction.SEARCH : url = endpoints.outlet.search;
        break;
        default : url = ''
    }
    const response = await fetch(url, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          "X-XSRF-TOKEN": csrf,
        },
        body: JSON.stringify(request),
      });
    
      return response.json()
}